import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./redux";

export const tailerStore = configureStore({
  reducer: {
    appReducer,
  },
});
